export default __webpack_public_path__ + "static/media/2021-talentum-mujeres.0d3a1a43.png";